import { Component, OnInit } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { DataService } from '../data.service';
import { StocksService } from '../stocks/stocks.service';

@Component({
    selector: 'app-allpaths',
    templateUrl: './allpaths.component.html',
    styleUrls: ['./allpaths.component.scss'],
    imports: [RouterLinkActive, RouterLink]
})
export class AllpathsComponent implements OnInit {
  constructor(
    private router: Router,
    private dataService: DataService,
    private stocksService: StocksService
  ) {}
  userLoggedIn = false;
  ngOnInit(): void {
    this.dataService.userLogged$.subscribe((data) => {
      console.log(data);
      this.userLoggedIn = data;
    });
  }

  logout() {
    this.stocksService.cleanCache();
    this.stocksService.clearNotification();
    this.dataService.setLoggedUser(undefined);
    this.router.navigate(['/login']);
  }
}
